import { render, staticRenderFns } from "./CardCourse.vue?vue&type=template&id=8340f2a6&scoped=true"
import script from "./CardCourse.js?vue&type=script&lang=js&external"
export * from "./CardCourse.js?vue&type=script&lang=js&external"
import style0 from "./CardCourse.scss?vue&type=style&index=0&id=8340f2a6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8340f2a6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTag: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Tag/Tag.vue').default,HotTitle: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
